export const redirects = {
  desktop:
    import.meta.env.VITE_DESKTOP_DETECTED_REDIRECT || 'https://verified.com.au',
  loginPath: import.meta.env.VITE_CAPTURE_LOGIN_PATH || '/login',
  sessionCompleted:
    import.meta.env.VITE_SESSION_COMPLETED_REDIRECT ||
    'https://verified.com.au',
  sessionExpired:
    import.meta.env.VITE_SESSION_ENDED_REDIRECT ||
    'https://webcontent.verified.com.au/session-ended/',
}
